import { EnvironmentProviders, Provider } from '@angular/core';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { reportsStoreFeatureName } from './consts';
import { ReportsMetricsEffects } from './metrics/metrics.effects';
import { ReportsMetricsHttpClient } from './metrics/metrics.http-client';
import { ReportsMetricsNamespace, ReportsMetricsReducer } from './metrics/metrics.store';
import { ReportsResultsEffects } from './results/results.effects';
import { ReportsResultsHttpClient } from './results/results.http-client';
import { ReportsResultsNamespace, ReportsResultsReducer } from './results/results.store';

const reportsState = provideState(reportsStoreFeatureName, {
  [ReportsMetricsNamespace]: ReportsMetricsReducer,
  [ReportsResultsNamespace]: ReportsResultsReducer,
});

const reportsEffects = provideEffects([ReportsMetricsEffects, ReportsResultsEffects]);

export const provideCoreReportsData = (): Array<EnvironmentProviders | Provider> => [
  ReportsMetricsHttpClient,
  ReportsResultsHttpClient,
  reportsState,
  reportsEffects,
];
